const unit = +window
  .getComputedStyle(document.documentElement)
  .getPropertyValue('--unit')
  .replace('px', '');

/**
 * Set video thumbnail margins based on screen size
 */
function setVideoLayout(video, defaultMarginTop) {
  const videoWidth = video.offsetWidth;

  if (videoWidth < 500) {
    video.style.setProperty('--v-thumb-margin-right', `${unit}px`);
    video.style.setProperty('--v-thumb-margin-top', `${unit}px`);
  } else if (videoWidth < 600) {
    video.style.setProperty('--v-thumb-margin-right', `${unit * 2}px`);
    video.style.setProperty('--v-thumb-margin-top', `${defaultMarginTop}`);
  } else {
    video.style.setProperty('--v-thumb-margin-right', `${unit * 3}px`);
    video.style.setProperty('--v-thumb-margin-top', `${defaultMarginTop}`);
  }
}

export default function videoComponent() {
  const videos = document.querySelectorAll('.video');

  videos.forEach((video) => {
    const defaultMarginTop = window
      .getComputedStyle(video)
      .getPropertyValue('--v-thumb-margin-top');
    setVideoLayout(video, defaultMarginTop);

    window.addEventListener('resize', () => {
      setTimeout(setVideoLayout(video, defaultMarginTop), 60);
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  videoComponent();
});

if (window.acf) {
  window.acf.addAction('render_block_preview', videoComponent);
}
